<lib-card [title]="'companies' | translate">
  <!-- Company Column Template -->
  <ng-template
    #companyTemplate
    let-row
  >
    <div class="company-cell">
      <div class="company-main">
        @if (getFlagUrl(row.companyProfile.countryIso2)) {
          <img
            [src]="getFlagUrl(row.companyProfile.countryIso2)"
            [alt]="row.companyProfile.countryIso2"
            class="country-flag"
          />
        }
        <div class="company-info">
          <span class="company-name">{{ row.companyProfile.name }}</span>
          <span class="company-did">{{ truncateDid(row.did) }}</span>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Credentials Column Template -->
  <ng-template
    #credentialsTemplate
    let-row
  >
    <div class="credentials-cell">
      @if (hasDigitalIdentity(row)) {
        <lib-badge label="Digital Identity" [colorScheme]="identityBadgeColor" />
      }
      @if (row.requestedCredentialTypes && row.requestedCredentialTypes.length > 0) {
        @for (credType of row.requestedCredentialTypes; track credType) {
          <lib-badge [label]="getCredentialLabel(credType)" [colorScheme]="credentialBadgeColor" />
        }
      }
      @if (!hasDigitalIdentity(row) && (!row.requestedCredentialTypes || row.requestedCredentialTypes.length === 0)) {
        <span class="no-credentials">—</span>
      }
    </div>
  </ng-template>

  <!-- Filters Section -->
  <div class="filters-container">
    <lib-input
      [value]="searchTerm()"
      (inputChange)="searchTerm.set($event)"
      [placeholder]="'search-companies-placeholder' | translate"
      [label]="'search-companies-label' | translate"
      type="text"
    />

    <lib-select
      [formControl]="credentialTypeFilterControl"
      [options]="credentialTypeOptions"
      [label]="'filter-by-credential' | translate"
      [placeholder]="'select-credential' | translate"
      [clearable]="false"
    />

    <lib-select
      [formControl]="statusFilterControl"
      [options]="statusOptions"
      [label]="'filter-by-status' | translate"
      [placeholder]="'select-status' | translate"
      [clearable]="false"
    />
  </div>

  <!-- Results Count -->
  <div
    class="results-count"
    aria-live="polite"
    aria-atomic="true"
  >
    {{
      'results-count'
        | translate: { filtered: filteredCompanies().length, total: companies().length }
    }}
  </div>

  <!-- Error State -->
  @if (error()) {
    <div
      class="error-message"
      role="alert"
    >
      <p>{{ 'error-loading-companies' | translate }}</p>
      <p class="error-details">{{ error() }}</p>
    </div>
  }

  <!-- Companies Table -->
  <lib-dynamic-table
    [data]="filteredCompanies()"
    [columns]="columns"
    [loading]="loading()"
    trackByKey="did"
    [rowClickable]="true"
    (rowClick)="onRowClick($event)"
  />
</lib-card>

<!-- Company Details Sliding View -->
<app-company-details-view
  [companyDid]="selectedCompanyDid() || ''"
  [isOpen]="isDetailsViewOpen()"
  (closed)="isDetailsViewOpen.set(false)"
  (credentialRevoked)="onCredentialRevoke($event)"
/>

<!-- Revoke Confirmation Modal -->
<app-company-status-modal
  [isOpen]="isRevokeModalOpen()"
  [companyName]="revokeModalCompanyName()"
  [credentialType]="revokeModalCredentialType()"
  [isLoading]="isProcessing()"
  (closed)="closeRevokeModal()"
  (confirmed)="confirmRevoke()"
/>
